import React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useFormikContext } from 'formik';

const LotProgressStatus = props => {
  const { values, handleChange } = useFormikContext();

  return (
    <FormControl fullWidth variant='outlined' size='small' {...props}>
      <InputLabel>Avancement dossier</InputLabel>
      <Select
        label='Avancement dossier'
        name='avancement_dossier'
        value={values.avancement_dossier}
        onChange={handleChange}
      >
        <MenuItem value='en preparation'>en preparation</MenuItem>
        <MenuItem value='en vente'>en vente</MenuItem>
        <MenuItem value='option'>option</MenuItem>
        <MenuItem value='pré-résa'>pré-résa</MenuItem>
        <MenuItem value='réservé'>réservé</MenuItem>
        <MenuItem value='rdv signature'>rdv signature</MenuItem>
        <MenuItem value='vendu'>vendu</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LotProgressStatus;
